module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_28.87e12a76.pdf";